module.exports = __webpack_public_path__ + "static/media/tribal-stars.5851041c.mp4";